// project-imports
import navigation from './navigation';
import users from './users';
import sms from './sms';
import ozeki from './ozeki';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [navigation, users, sms, ozeki]
};

export default menuItems;
